import { render } from "./MatchProfileAnalysis.vue?vue&type=template&id=f1ac4eee"
import script from "./MatchProfileAnalysis.vue?vue&type=script&lang=js"
export * from "./MatchProfileAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__